import { Avatar, Spinner } from '@acpaas-ui/react-components';
import { activityUserToInitials } from '../../lib/activity.utils';
import { userToString } from '../../lib/auth.utils';
import { dateToDateString } from '../../lib/date.utils';

const ActivityItemMeta = ({ user, category, date, pinnedBy, flyoutMenu, isUpdating }) => {
  const userInitials = activityUserToInitials(user);
  return (
    <div className="spo-m-dossier-sidebar-activity__item-meta">
      <Avatar
        size="small"
        letter={!user?.avatarUrl ? userInitials : ''}
        icon={!userInitials && !user?.avatarUrl ? 'ai-single-neutral' : undefined}
        image={user?.avatarUrl}
      />
      <div className="user-info">
        <p className="u-text-bold">{userToString(user)}</p>
        <p className="date u-text-light">
          {dateToDateString(date, true)}
          {category ? ` | ${category}` : ''}
        </p>
      </div>
      {isUpdating ? (
        <div className="updating">
          <Spinner size="small" />
        </div>
      ) : (
        flyoutMenu
      )}
      {pinnedBy && (
        <p className="pinned-by u-text-light">
          vastgezet door <span className="u-text-bold">{userToString(pinnedBy)}</span>
        </p>
      )}
    </div>
  );
};

export default ActivityItemMeta;
